import React from 'react';
import Filter, { FilterModal, FilterSection } from './Filter';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';

import styles from '../search.scss';

const EventUtrTypeFilter = (props) => {
    const { filters, filterModal, handleFilterClick, closeModals, filterInputs, searchTypes, handleFilterSubmit, clearFilters, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'eventUtrType'}
                handleFilterClick={handleFilterClick}
                isActive={(filters && filters.eventUtrTypes && Object.values(filters.eventUtrTypes).indexOf(true) > -1) || filterModal === 'eventUtrType'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Verified Event
            </Filter>
            {filterModal === 'eventUtrType' && (
                <FilterModal
                    title={'Type'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters('eventUtrType')}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <CheckboxFilterByType
                            searchTypes={searchTypes}
                            searchTypesPropName={`utrType`}
                            filterInputs={filterInputs}
                            filtersPropName={`eventUtrTypes`}
                            onChange={(value) => {
                                handleFilterUpdate({
                                    eventUtrTypes: {
                                        ...filterInputs.eventUtrTypes,
                                        [value]: !filterInputs.eventUtrTypes[value],
                                    },
                                });
                            }}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

export default EventUtrTypeFilter;
